<div class="row">
  <div class="col-12">
    <h3 *appApplyIfNotEmpty="translationService.getTranslation('subscription_intro')"
        [innerHTML]="translationService.getTranslation('subscription_intro')"></h3>
  </div>
  <div class="col-12">
    <h4 [innerHTML]="translationService.getTranslation('subscription_description')"></h4>
  </div>

  <!--  <div class="col-12 col-md-9">-->
  <!--    <h4 [innerHTML]="translationService.getTranslation('text_payment')"></h4>-->
  <!--  </div>-->
  <!--  <div class="col-12 col-md-3">-->
  <!--    <a routerLink="/payment"><button mat-raised-button>{{translationService.getTranslation('text_payment')}}</button></a>-->
  <!--  </div>-->
</div>
<div class="row">
  <div class="col-12">
    <div *ngIf="isLoading" style="text-align: center;">
      <app-loading-spinner></app-loading-spinner>
    </div>
    <div *ngIf="!isLoading && subs.length == 0" [innerHTML]="translationService.getTranslation('intro_noSubs')">
    </div>
    <ng-container *ngIf="!isLoading && subs.length > 0">
      <mat-card appearance="outlined" *ngFor="let sub of subs; let i = index" class="mt-3">
        <div class="row m-3">
          <div tabindex="0" class="col-12 col-md-6">
            <mat-card-title>{{sub.productDescription}}
              <div class="subscription-status float-end me-5" [ngSwitch]="sub.state" *ngIf="showSubscriptionStatus">
                <div *ngSwitchCase="'-1'" [innerHTML]="translationService.getTranslation('orderstatus_admintool')"></div>
                <div *ngSwitchCase="'0'" [innerHTML]="translationService.getTranslation('orderstatus_active')"></div>
                <div *ngSwitchCase="'1'" [innerHTML]="translationService.getTranslation('orderstatus_future')"></div>
                <div *ngSwitchCase="'3'" [innerHTML]="translationService.getTranslation('orderstatus_terminated')"></div>
              </div>
            </mat-card-title>
            <mat-card-subtitle *ngIf="sub.subId" [innerHTML]="translationService.getTranslation('order_id') + ': ' + sub.subId">
            </mat-card-subtitle>
            <mat-card-subtitle *ngIf="sub.userBackendId" [innerHTML]="translationService.getTranslation('label_backendid') + ': ' + sub.userBackendId">
            </mat-card-subtitle>
            <mat-card-subtitle *ngIf="sub.variantDescription" [innerHTML]="translationService.getTranslation('order_edition') + ': ' + sub.variantDescription">
            </mat-card-subtitle>
            <mat-card-subtitle *ngIf="sub.validDate" [innerHTML]="translationService.getTranslation('period') + ': ' +
                               (sub.validDate.validFrom | date) + ' - ' +
                               ((sub.validDate.validUntil) ? (sub.validDate.validUntil | date) : translationService.getTranslation('subscription_endless'))">
            </mat-card-subtitle>
            <mat-card-subtitle *ngIf="sub.curDelivery">
              {{sub.curDelivery.person.addressCodeDescription}}
              {{sub.curDelivery.person.firstname}}
              {{sub.curDelivery.person.lastname}},
              {{sub.curDelivery.address.city}},
              {{sub.curDelivery.address.street}} {{sub.curDelivery.address.houseno | houseNoPipe}}
            </mat-card-subtitle>
          </div>
          <div class="col-12 col-md-6">
            <mat-card-actions class="card-actions">
              <!--
              <button mat-raised-button color="primary" *ngIf="sub.state === -1"
                      (click)="cancelOrder(sub)">{{translationService.getTranslation('button_storno')}}</button>
                      -->
              <button mat-raised-button color="primary" [innerHTML]="translationService.getTranslation('button_details')"
                      (click)="aboDetails(sub)"></button>
            </mat-card-actions>
          </div>
        </div>
      </mat-card>
    </ng-container>
  </div>
</div>
